__turbopack_context__.v({
  "marquee": "_trusted-companies-module-scss-module__qwwv5G__marquee",
});
